import { Component } from '@theme/component';

class ProductInfoDrawer extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.dialog = this.querySelector('dialog');
    this.closeBtn = this.querySelector('[data-drawer-close]');

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close);
    }

    if (this.dialog) {
      this.dialog.addEventListener('click', this.#handleBackdropClick);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.close);
    }

    if (this.dialog) {
      this.dialog.removeEventListener('click', this.#handleBackdropClick);
    }
  }

  open = () => {
    if (!this.dialog || this.dialog.open) return;
    this.dialog.showModal();
    document.body.style.overflow = 'hidden';
  };

  close = () => {
    if (!this.dialog || !this.dialog.open) return;
    this.dialog.close();
    document.body.style.overflow = '';
    this.#removeHashParamFromUrl();
  };

  #handleBackdropClick = (event) => {
    if (event.target === this.dialog) {
      this.close();
    }
  };

  #removeHashParamFromUrl = () => {
    const paramName = this.dataset.openOnHashParam;
    const expectedValue = this.dataset.openOnHashValue ?? 'true';

    if (!paramName) return;

    const url = new URL(window.location.href);
    const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
    const actualValue = hashParams.get(paramName);

    if (actualValue !== expectedValue) return;

    hashParams.delete(paramName);

    const nextHash = hashParams.toString();
    const nextUrl = `${url.pathname}${url.search}${nextHash ? `#${nextHash}` : ''}`;
    window.history.replaceState({}, '', nextUrl);
  };
}

if (!customElements.get('product-info-drawer')) {
  customElements.define('product-info-drawer', ProductInfoDrawer);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-drawer-target]');
  if (!trigger) return;

  event.preventDefault();

  const drawerId = trigger.getAttribute('data-drawer-target');
  const drawer = document.getElementById(drawerId);

  if (drawer instanceof ProductInfoDrawer) {
    drawer.open();
  }
});

const openDrawerFromHashParam = () => {
  const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const drawers = document.querySelectorAll('product-info-drawer[data-open-on-hash-param]');

  drawers.forEach((drawer) => {
    if (!(drawer instanceof ProductInfoDrawer)) return;

    const paramName = drawer.dataset.openOnHashParam;
    const expectedValue = drawer.dataset.openOnHashValue ?? 'true';

    if (!paramName) return;

    const actualValue = hashParams.get(paramName);

    if (actualValue === expectedValue) {
      drawer.open();
    }
  });
};

window.addEventListener('hashchange', openDrawerFromHashParam);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openDrawerFromHashParam, { once: true });
} else {
  openDrawerFromHashParam();
}
